import React from "react";
import PropTypes from "prop-types";
import * as ReactRedux from "react-redux";
import { Link } from "react-router";

import { pointerStyle } from "../../styles.js";

import moment from "moment";

import { momentDateFormat }  from "../../../config.js";

import { Check, Warning, Pencil } from "../../components/Icons.jsx";

// import { fetchCountries, fetchStates } from "../actions/location_info.js";
import { fetchProfileInfo } from "../actions/profile_info.js";
import { getGender, getEducationStatus, getMaritalStatus } from "../../utils.js";
import Loading from "../../components/Loading.jsx";

class ProfileInfoPanelBase extends React.Component {
	static propTypes = {
		profileInfo: PropTypes.shape({
			id: PropTypes.number,
			date_of_birth: PropTypes.string,
			first_name: PropTypes.string,
			last_name: PropTypes.string,
			gender: PropTypes.string,
			education: PropTypes.string,
			address: PropTypes.string,
			marital_status: PropTypes.string,
			pincode: PropTypes.string,
			city: PropTypes.shape({
				name: PropTypes.string,
			}),
			is_complete: PropTypes.bool,
			mobile_number: PropTypes.string,
		}),
		dispatch: PropTypes.func.isRequired,
	};

	state = {
		expanded: false,
	};

	toggleExpand = () => {
		this.setState({expanded: !this.state.expanded});
	};

	componentDidMount() {
		this.props.dispatch(fetchProfileInfo());
		// this.props.dispatch(fetchCountries());
		// this.props.dispatch(fetchStates());
	}

	render() {
		if(!this.props.profileInfo.id){
			return <Loading/>;
		}

		var dateOfBirth;
		var date =  moment(this.props.profileInfo.date_of_birth);
		if (date.isValid()){
			dateOfBirth = date.format(momentDateFormat);
		}
		var auditorCity = this.props.profileInfo.city || {};

		let panelClass = "panel-default";

		if( ! this.props.profileInfo.is_complete && this.props.profileInfo.mobile_number){
			var completeWarning = (
				<div className="panel-footer">
					<p className="text-danger"><b>Please complete your personal information.</b></p>
				</div>
			);
		} else {
			panelClass = "panel-success-hoverable";
		}

		let panelIcon = this.props.profileInfo.is_complete ? <Check/> : <Warning/>;

		return (
			<div className={"panel " + panelClass}>
				<div className="panel-heading" style={pointerStyle} onClick={this.toggleExpand}>
					{ this.state.expanded || !this.props.profileInfo.is_complete ? <Link to="details/profile/edit" className="btn btn-default pull-right"><Pencil/> Edit</Link> : null }
					<h4>{panelIcon} Personal Information</h4>
				</div>
				{ this.state.expanded || !this.props.profileInfo.is_complete ?
					<table className="table table-striped">
						<colgroup>
							<col style={{width:"40%"}}/>
						</colgroup>
						<tbody>
							<tr><td className="text-muted text-right" style={{"width":"40%"}}><span className="text-danger"><b>*</b></span>First Name:</td><th>{this.props.profileInfo.first_name}</th></tr>
							<tr><td className="text-muted text-right"><span className="text-danger"><b>*</b></span>Last Name:</td><th>{this.props.profileInfo.last_name}</th></tr>
							<tr><td className="text-muted text-right"><span className="text-danger"><b>*</b></span>Gender:</td><th>{getGender(this.props.profileInfo.gender)}</th></tr>
							<tr><td className="text-muted text-right"><span className="text-danger"><b>*</b></span>Education:</td><th>{getEducationStatus(this.props.profileInfo.education)}</th></tr>
							<tr><td className="text-muted text-right"><span className="text-danger"><b>*</b></span>Date of Birth:</td><th>{dateOfBirth}</th></tr>
							<tr><td className="text-muted text-right"><span className="text-danger"><b>*</b></span>Marital Status:</td><th>{getMaritalStatus(this.props.profileInfo.marital_status)}</th></tr>
							<tr><td className="text-muted text-right"><span className="text-danger"><b>*</b></span>Address:</td><th>{this.props.profileInfo.address}</th></tr>
							<tr><td className="text-muted text-right"><span className="text-danger"><b>*</b></span>City:</td><th>{auditorCity.name}</th></tr>
							<tr><td className="text-muted text-right"><span className="text-danger"><b>*</b></span>State:</td><th>{auditorCity.state}</th></tr>
							<tr><td className="text-muted text-right"><span className="text-danger"><b>*</b></span>Country:</td><th>{auditorCity.country}</th></tr>
							<tr><td className="text-muted text-right"><span className="text-danger"><b>*</b></span>Pincode:</td><th>{this.props.profileInfo.pincode}</th></tr>
						</tbody>
					</table>
					: null }
				{completeWarning}
			</div>
		);
	}
}

var mapStoreToProps = function(store){
	return {
		profileInfo: store.profileInfo,
		// countries: store.countries,
		// states: store.states,
	};
};

export { ProfileInfoPanelBase };
export default ReactRedux.connect(mapStoreToProps)(ProfileInfoPanelBase);
